<template>
  <div class="sczjsj-container">
    <el-row class="tcf-row" v-loading="loading">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            <el-button-group>
              <el-button :type="mark===0?'primary':''" size="small" @click="changeMark(0)">正单数据</el-button>
              <el-button :type="mark===1?'primary':''" size="small" @click="changeMark(1)">补单数据</el-button>
            </el-button-group>
            <el-form :inline="true" size="small" :rules="rules" :model="searchForm" style="float: right;">
              <el-form-item label="选择月份">
                <el-date-picker
                  v-model="searchForm.time"
                  type="month"
                  format="yyyy年MM月"
                  value-format="yyyy-MM"
                  placeholder="选择月份">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button :loading="btnLoading" icon="el-icon-s-data" type="primary" @click="getData">统计</el-button>
                <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <el-row>
              <el-col v-if="mark===0" :span="24">
                <table class="tcf-bb-table">
                    <tr>
                      <th rowspan="2">序号</th>
                      <th rowspan="2">生产单号</th>
                      <th rowspan="2">专卖店</th>
                      <th rowspan="2">重点客户</th>
                      <th rowspan="2">客户地址</th>
                      <th rowspan="2">工艺颜色</th>
                      <th rowspan="2">订单内容描述</th>
                      <th rowspan="2">金额</th>
                      <th rowspan="2">生产接单时间</th>
                      <th rowspan="2">色板确认时间</th>
                      <th rowspan="2">变更单</th>
                      <th rowspan="2">订单交期</th>
                      <th rowspan="2">实际完成日期</th>
                      <th rowspan="2">交期剩余天数</th>
                      <th rowspan="2">类别</th>
                      <th rowspan="2">木工工艺</th>
                      <th rowspan="2">混油帖皮</th>
                      <th rowspan="2">面漆工艺</th>
                      <th rowspan="2">包装工艺</th>
                      <th colspan="3">①木工配套组</th>
                      <th colspan="3">②UV</th>
                      <th colspan="3">③组装</th>
                      <th colspan="3">④油磨</th>
                      <th colspan="3">⑤检验</th>
                      <th colspan="3">⑥面漆组</th>
                      <th colspan="3">⑦包装</th>
                      <th>异常动态</th>
                    </tr>
                    <tr>
                      <th>计划</th>
                      <th>实际</th>
                      <th>动态</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>动态</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>动态</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>动态</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>动态</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>动态</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>动态</th>
                      <th>具体原因</th>
                    </tr>
                    <tr v-for="item in orderDeliveryDetailList">
                      <td>{{item.xuhao}}</td>
                      <td>{{item.productNum}}</td>
                      <td>{{item.shop}}</td>
                      <td>{{item.level}}</td>
                      <td>{{item.address}}</td>
                      <td></td>
                      <td>{{item.desc}}</td>
                      <td>{{item.price}}</td>
                      <td>{{item.factoryTime}}</td>
                      <td></td>
                      <td></td>
                      <td>{{item.submitTime}}</td>
                      <td>{{item.realTime}}</td>
                      <td>{{item.lastDays}}</td>
                      <td></td>
                      <td>{{item.woodDays}}</td>
                      <td></td>
                      <td></td>
                      <td>{{item.packDays}}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{{item.planPackTime}}</td>
                      <td>{{item.realPackTime}}</td>
                      <td></td>
                      <td></td>
                    </tr>
                </table>
                <table class="tcf-bb-table">
                    <tr>
                      <th>日期</th>
                      <th colspan="15">{{orderDeliveryDetailMap.year}}年{{orderDeliveryDetailMap.month}}月{{orderDeliveryDetailMap.firstDay}}日~{{orderDeliveryDetailMap.year}}年{{orderDeliveryDetailMap.month}}月{{orderDeliveryDetailMap.lastDay}}日</th>
                    </tr>
                    <tr>
                      <th>计划（个）</th>
                      <th>订单实际完成（个）</th>
                      <th>未完成（个）</th>
                      <th>订单达成率</th>
                      <th>准交订单（个）</th>
                      <th>延期订单（个）</th>
                      <th>生产异常影响（个）</th>
                      <th>无条码（个）</th>
                      <th>物料影响（个）</th>
                      <th>变更单（个）</th>
                      <th>交期不合理（个）</th>
                      <th>准交率</th>
                      <th>实际完产能</th>
                      <th>未完成产能</th>
                      <th>补单完成+正单完成总产能</th>
                      <th>除物料等影响总交期达成率</th>
                    </tr>
                    <tr>
                      <td>{{orderDeliveryDetailMap.total}}</td>
                      <td>{{orderDeliveryDetailMap.comp}}</td>
                      <td>{{orderDeliveryDetailMap.noComp}}</td>
                      <td>{{orderDeliveryDetailMap.rate}}%</td>
                      <td /><td /><td /><td /><td /><td />
                      <td /><td /><td /><td /><td /><td />
                    </tr>
                </table>
              </el-col>
              <el-col v-if="mark===1" :span="24">
                <table class="tcf-bb-table">
                    <tr>
                      <th rowspan="2">序号</th>
                      <th rowspan="2">补单单号</th>
                      <th rowspan="2">正单号</th>
                      <th rowspan="2">补件类别</th>
                      <th rowspan="2">客户</th>
                      <th rowspan="2">工艺颜色</th>
                      <th rowspan="2">订单内容描述</th>
                      <th rowspan="2">金额</th>
                      <th rowspan="2">厂部承担金额</th>
                      <th rowspan="2">设计师</th>
                      <th rowspan="2">生产接单时间</th>
                      <th rowspan="2">订单交期</th>
                      <th rowspan="2">生产进度</th>
                      <th rowspan="2">预审交期</th>
                      <th rowspan="2">交期剩余天数</th>
                      <th rowspan="2">木工工艺</th>
                      <th rowspan="2">面漆工艺</th>
                      <th rowspan="2">包装工艺</th>
                      <th colspan="2">①木工</th>
                      <th colspan="2">②油磨</th>
                      <th colspan="2">③面漆</th>
                      <th colspan="2">④包装</th>
                      <th colspan="3">汇总</th>
                      <th colspan="4">异常动态</th>
                      <th colspan="4">各工段计划延误天数</th>
                      <th colspan="4">各工段自身原因延误天数</th>
                      <th rowspan="2">补单交期延误天数</th>
                      <th rowspan="2">实际周期</th>
                    </tr>
                    <tr>
                      <th>计划</th>
                      <th>实际</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>计划</th>
                      <th>实际</th>
                      <th>工段</th>
                      <th>检验</th>
                      <th>数据达成情况</th>
                      <th>色板状态</th>
                      <th>物料</th>
                      <th>具体内容</th>
                      <th>实际完成</th>
                      <th>木工</th>
                      <th>油磨</th>
                      <th>面漆</th>
                      <th>包装</th>
                      <th>木工</th>
                      <th>油磨</th>
                      <th>面漆</th>
                      <th>包装</th>
                    </tr>
                    <tr v-for="item in addOrderDeliveryDetail">
                      <td>{{item.xuhao}}</td>
                      <td>{{item.productNum}}</td>
                      <td /> <td />
                      <td>{{item.shop}}</td>
                      <td>{{item.color}}</td>
                      <td>{{item.desc}}</td>
                      <td>{{item.price}}</td>
                      <td>{{item.factoryPrice}}</td>
                      <td>{{item.splitName}}</td>
                      <td>{{item.factoryTime}}</td>
                      <td>{{item.submitTime}}</td>
                      <td /><td />
                      <td>{{item.lastDays}}</td>
                      <td/> <td/> <td/>
                      <td>{{item.planWoodTime}}</td>
                      <td>{{item.realWoodTime}}</td>
                      <td/> <td/> <td/> <td/>
                      <td>{{item.planPackTime}}</td>
                      <td>{{item.realPackTime}}</td>
                      <td /> <td /> <td /> <td /> <td />
                      <td /> <td /> <td /> <td /> <td />
                      <td /> <td /> <td /> <td /> <td />
                      <td /> <td />
                    </tr>
                </table>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderDeliveryDetail, getAddOrderDeliveryDetail } from '@/api/tj'
import { dateFormat } from '@/utils/index'

export default {
  name: 'sczjsj',
  data() {
    return {
      tableData: [],
      searchForm: {
        time: ''
      },
      rules: {
        time: [{ required: true, message: '请选择月份', trigger: 'change' }]
      },
      btnLoading: false,
      mark: 0,
      orderDeliveryDetailMap: {},
      orderDeliveryDetailList: [],
      addOrderDeliveryDetail: {},
      loading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    const end = new Date()
    const endTime = dateFormat('YYYY-mm', end)
    this.searchForm.time = endTime
    this.getData()
  },
  methods: {
    changeMark(val) {
      this.mark = val
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        month: this.searchForm.time,
        type: 0
      }
      this.btnLoading = true
      if (this.mark === 0) {
        getOrderDeliveryDetail(data).then(response => {
          this.orderDeliveryDetailList = response.data.list
          this.orderDeliveryDetailMap = response.data.map
          this.btnLoading = false
          this.loading = false
        }).catch(() => {
          this.btnLoading = false
          this.loading = false
        })
      } else {
        getAddOrderDeliveryDetail(data).then(response => {
          this.addOrderDeliveryDetail = response.data
          this.btnLoading = false
          this.loading = false
        }).catch(() => {
          this.btnLoading = false
          this.loading = false
        })
      }
    },
    exportExcel() {
      const data = {
        month: this.searchForm.time,
        type: 1
      }
      this.btnLoading = true
      let file = null
      if (this.mark === 0) {
        getOrderDeliveryDetail(data).then(response => {
          file = response.data
          this.downLoad(file)
          this.btnLoading = false
          this.loading = false
        }).catch(() => {
          this.btnLoading = false
          this.loading = false
        })
      } else {
        getAddOrderDeliveryDetail(data).then(response => {
          file = response.data
          this.downLoad(file)
          this.btnLoading = false
          this.loading = false
        }).catch(() => {
          this.btnLoading = false
          this.loading = false
        })
      }
    },
    downLoad(file) {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', file.dPath, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = file.dName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${file.dName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
    }
  }

}
</script>
<style lang="scss" scoped>
  .tcf-bb-table{
    width: 100%;
    background-color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 13px;
    text-align: center;
    margin-top: 20px;
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 12px 0;
      }
      td{
        border: 1px solid #EBEEF5;
        color: #303133;
        padding: 12px 0;
      }
      &:hover{
        background: #f3f6f9;
      }
    }
  }
</style>
